import React from "react";
import "./Travel.css";
import Erp_software from "./Products/school-erp-hero.jpg";
import travel_business from "./Products/school-erp1.png";
import travel_erp from "./Products/school-erp2.jpg";
import { Helmet } from "react-helmet-async";
import Banner from "../../Banner/Banner";

const SchoolERP = () => {
  return (
    <>

      <Helmet>
        <title>Easy School ERP Software for Modern Schools</title>

        <meta
          name="description"
          content="Our easy school ERP software helps manage students, fees, attendance, exams and communication in one system designed for smooth and modern school management."
        />

        <meta
          name="keywords"
          content="Student portal, Campus management, School database, Education software, School system, Exam management, Academic management, School automation" />

        {/* <!-- Canonical URL --> */}
        <link rel="canonical" href="https://kitkatsoftwaretechnologies.com/school-erp" />

        {/* <!-- Hreflang Tags --> */}
        <link rel="alternate" hrefLang="en-US" href="https://kitkatsoftwaretechnologies.com/school-erp" />
        <link rel="alternate" hrefLang="en-GB" href="https://kitkatsoftwaretechnologies.com/school-erp" />
        <link rel="alternate" hrefLang="en-MY" href="https://kitkatsoftwaretechnologies.com/school-erp" />
        <link rel="alternate" hrefLang="en-SG" href="https://kitkatsoftwaretechnologies.com/school-erp" />
        <link rel="alternate" hrefLang="en-AE" href="https://kitkatsoftwaretechnologies.com/school-erp" />
        <link rel="alternate" hrefLang="x-default" href="https://kitkatsoftwaretechnologies.com/school-erp" />

      </Helmet>
      
      <Banner image={Erp_software} alt="School ERP" />

      <div className="content_lists">
        <div className="product_cont">
          <div className="career_p">
            <h1 className="product_title">All-In-One School ERP Software for Management</h1>
            <p className="cont_para_style">
              School ERP from KitKat Software Technologies is a comprehensive solution designed to
              manage academic, administrative, financial, staff, and student information within a
              single, integrated platform. We develop institution-focused ERP systems that are fully
              customized to meet the specific requirements of schools, colleges, and educational
              institutions.
            </p>
            <p className="cont_para_style">
              Our School ERP system centralizes all core administrative activities, including
              attendance tracking, student record management, grading and examination
              management, timetable scheduling, fee collection, payroll, and communication
              management. By automating daily operations, the software significantly reduces manual
              paperwork, minimizes errors, and improves data accuracy. This allows teachers,
              administrators, and staff to focus more on delivering quality education and supporting
              student development rather than handling routine administrative tasks.            </p>
            <div className="side_img1">
              <img
                src={travel_business}
                width="100%"
                height="100%"
                alt="Travel Business Software"
                style={{ objectFit: "cover" }}
              />
            </div>
            <p className="cont_para_style">
              The system provides real-time access to information, enabling school management to
              make informed decisions quickly and efficiently. With secure data storage, role-based
              access, and easy report generation, institutions can ensure transparency and smooth
              coordination between departments. Parents and students can also benefit from
              streamlined communication and timely updates.
            </p>{" "}
            <p className="cont_para_style">
              At KitKat Software Technologies, we design scalable and user-friendly School ERP
              solutions that improve operational efficiency, reduce workload, and simplify
              institutional management. Our goal is to empower educational institutions with
              technology that supports academic excellence and long-term growth.
            </p>

            <div className="side_img1">
              <img
                src={travel_erp}
                width="100%"
                height="100%"
                alt="Travel ERP Software"
                style={{ objectFit: "cover" }}
              />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default SchoolERP;
